var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVgmicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.987793 5.33366C0.987793 3.13391 0.987793 2.03374 1.67146 1.35066C2.35454 0.666992 3.45471 0.666992 5.65446 0.666992H6.82113C9.02088 0.666992 10.121 0.666992 10.8041 1.35066C11.4878 2.03374 11.4878 3.13391 11.4878 5.33366V7.66699C11.4878 9.86674 11.4878 10.9669 10.8041 11.65C10.121 12.3337 9.02088 12.3337 6.82113 12.3337H5.65446C3.45471 12.3337 2.35454 12.3337 1.67146 11.65C0.987793 10.9669 0.987793 9.86674 0.987793 7.66699V5.33366Z",
    stroke: "black",
    strokeWidth: 1.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9043 5.33389H8.57096M3.9043 7.66723H6.82096",
    stroke: "black",
    strokeWidth: 1.05,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVgmicon);
export default __webpack_public_path__ + "static/media/vgmicon.a9ebae4a38a92651b39d79b0cd4bd4ec.svg";
export { ForwardRef as ReactComponent };